import { AuthUser } from "@/types/firebase";
import React from "react";

export const AuthUserContext = React.createContext<AuthUser | null | undefined>(
  undefined
);
